// © Microsoft Corporation. All rights reserved.

import AbortController from "abort-controller";

// TODO (https://microsoft.visualstudio.com/OS/_workitems/edit/27301258/) - Make AbortController polyfill for IE.

/**
 * Fetch with timeout and close connection
 * @param url fetch url
 * @param timeoutMs timeout in miliseconds before rejecting the fetch
 */
export async function abortableFetch(url: string, timeoutMs: number): Promise<Response> {
    const controller: AbortController = new AbortController();

    const timeout = setTimeout(() => {
        controller.abort();
    }, timeoutMs);

    return fetch(url, { signal: controller.signal })
        .then(response => response)
        .catch(err => {
            if (err.name === "AbortError") {
                throw new Error(`Fetch aborted due to timeout of ${timeoutMs} ms.`);
            }
            throw new Error(err);
        })
        .finally(() => {
            clearTimeout(timeout);
        });
}